const AVATAR_COLOR_CLASSES = [
  "bg-indigo-100 text-indigo-700",
  "bg-emerald-100 text-emerald-700",
  "bg-amber-100 text-amber-700",
  "bg-rose-100 text-rose-700",
  "bg-sky-100 text-sky-700",
  "bg-violet-100 text-violet-700",
  "bg-teal-100 text-teal-700",
  "bg-orange-100 text-orange-700",
];

export function getAvatarColorClass(seed: string | null | undefined): string {
  const value = seed ?? "";
  let hash = 0;

  for (let i = 0; i < value.length; i++) {
    hash = (hash * 31 + value.charCodeAt(i)) % AVATAR_COLOR_CLASSES.length;
  }

  return AVATAR_COLOR_CLASSES[hash];
}
